<script setup lang="ts">

import {computed, ref} from "vue";
import {timeoffBackend} from "@/backend/timeoff.backend.ts";
import TimeOffList from "@/components/timeoff/TimeOffList.vue";
import {isSelf} from "@/composables/useAppUser.ts";
import TimeoffApprover from "@/components/timeoff/TimeoffApprover.vue";
import {useAuthStore} from "@/stores";

const { profile } = defineProps(['profile'])

const timeoffList = ref(await timeoffBackend.getPersonTimeoff(profile.user.id))
const {isApprover} = useAuthStore()

async function refreshTimeoffs() {
  timeoffList.value = await timeoffBackend.getPersonTimeoff(profile.user.id)
}

const canSeeComments = computed(() => {
  return isApprover.value || isSelf(profile.user)
})

</script>

<template>
  <div>
    <TimeOffList :timeoffList="timeoffList" :hide-name="true" :hide-comment="!canSeeComments" v-if="timeoffList">
      <template #timeoffActions="slotProps">
        <TimeoffApprover :timeoff="slotProps.data" @refresh="refreshTimeoffs" v-if="isApprover" />
      </template>
    </TimeOffList>
  </div>
</template>
